var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "lg": "4"
    }
  }, [_c('iq-card', {
    attrs: {
      "class-name": "iq-user-profile-block1"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function fn() {
        var _vm$form$personal_dat, _vm$form, _vm$form$personal_dat2, _vm$form$personal_dat3, _vm$form2, _vm$form2$personal_da, _vm$form$personal_dat4, _vm$form3, _vm$form3$personal_da, _vm$form$apply_date, _vm$form4, _vm$form$personal_dat5, _vm$form5, _vm$form5$personal_da, _vm$form$personal_dat6, _vm$form6, _vm$form6$personal_da, _vm$form$personal_dat7, _vm$form7, _vm$form7$personal_da, _vm$form7$personal_da2, _vm$form$personal_dat8, _vm$form8, _vm$form8$personal_da, _vm$form$personal_dat9, _vm$form9, _vm$form9$personal_da, _vm$form$personal_dat10, _vm$form10, _vm$form10$personal_d, _vm$form$personal_dat11, _vm$form11, _vm$form11$personal_d, _vm$form11$personal_d2, _vm$form$personal_dat12, _vm$form12, _vm$form12$personal_d, _vm$form$personal_dat13, _vm$form13, _vm$form13$personal_d, _vm$form13$personal_d2, _vm$form$personal_dat14, _vm$form14, _vm$form14$personal_d, _vm$form14$personal_d2, _vm$form$alamat_ktp$, _vm$form15, _vm$form15$alamat_ktp, _vm$form15$alamat_ktp2, _vm$form$alamat_domis, _vm$form16, _vm$form16$alamat_dom, _vm$form16$alamat_dom2;
        return [_c('div', {
          staticClass: "user-details-block"
        }, [_c('div', {
          staticClass: "user-profile text-center"
        }, [_c('img', {
          staticClass: "avatar-130 img-fluid",
          attrs: {
            "src": (_vm$form$personal_dat = (_vm$form = _vm.form) === null || _vm$form === void 0 ? void 0 : (_vm$form$personal_dat2 = _vm$form.personal_data) === null || _vm$form$personal_dat2 === void 0 ? void 0 : _vm$form$personal_dat2.photo) !== null && _vm$form$personal_dat !== void 0 ? _vm$form$personal_dat : '../../assets/images/user/11.png',
            "alt": "profile-img"
          }
        })]), _c('div', {
          staticClass: "text-center mt-3"
        }, [_c('h4', [_c('b', [_vm._v(_vm._s((_vm$form$personal_dat3 = (_vm$form2 = _vm.form) === null || _vm$form2 === void 0 ? void 0 : (_vm$form2$personal_da = _vm$form2.personal_data) === null || _vm$form2$personal_da === void 0 ? void 0 : _vm$form2$personal_da.full_name) !== null && _vm$form$personal_dat3 !== void 0 ? _vm$form$personal_dat3 : '-'))])]), _c('p', [_vm._v(" " + _vm._s(_vm.countAge) + " Tahun, " + _vm._s((_vm$form$personal_dat4 = (_vm$form3 = _vm.form) === null || _vm$form3 === void 0 ? void 0 : (_vm$form3$personal_da = _vm$form3.personal_data) === null || _vm$form3$personal_da === void 0 ? void 0 : _vm$form3$personal_da.place_of_birth) !== null && _vm$form$personal_dat4 !== void 0 ? _vm$form$personal_dat4 : '-') + " "), _c('br'), _c('b-badge', {
          attrs: {
            "variant": "primary"
          }
        }, [_vm._v("Apply Date, " + _vm._s((_vm$form$apply_date = (_vm$form4 = _vm.form) === null || _vm$form4 === void 0 ? void 0 : _vm$form4.apply_date) !== null && _vm$form$apply_date !== void 0 ? _vm$form$apply_date : '-'))])], 1)])]), _c('table', {
          staticClass: "table table-striped"
        }, [_c('tbody', [_c('tr', {
          staticClass: "bg-info"
        }, [_c('td', {
          staticClass: "text-center",
          attrs: {
            "colspan": "2"
          }
        }, [_c('strong', [_vm._v("DATA DIRI")])])]), _c('tr', [_c('td', [_c('strong', [_vm._v("Tempat/Tanggal Lahir")])]), _c('td', [_vm._v(_vm._s((_vm$form$personal_dat5 = (_vm$form5 = _vm.form) === null || _vm$form5 === void 0 ? void 0 : (_vm$form5$personal_da = _vm$form5.personal_data) === null || _vm$form5$personal_da === void 0 ? void 0 : _vm$form5$personal_da.place_of_birth) !== null && _vm$form$personal_dat5 !== void 0 ? _vm$form$personal_dat5 : '-') + " / " + _vm._s((_vm$form$personal_dat6 = (_vm$form6 = _vm.form) === null || _vm$form6 === void 0 ? void 0 : (_vm$form6$personal_da = _vm$form6.personal_data) === null || _vm$form6$personal_da === void 0 ? void 0 : _vm$form6$personal_da.date_of_birth) !== null && _vm$form$personal_dat6 !== void 0 ? _vm$form$personal_dat6 : '-'))])]), _c('tr', [_c('td', [_c('strong', [_vm._v("Jabatan/Ijazah")])]), _c('td', [_vm._v(_vm._s((_vm$form$personal_dat7 = (_vm$form7 = _vm.form) === null || _vm$form7 === void 0 ? void 0 : (_vm$form7$personal_da = _vm$form7.personal_data) === null || _vm$form7$personal_da === void 0 ? void 0 : (_vm$form7$personal_da2 = _vm$form7$personal_da.position) === null || _vm$form7$personal_da2 === void 0 ? void 0 : _vm$form7$personal_da2.name) !== null && _vm$form$personal_dat7 !== void 0 ? _vm$form$personal_dat7 : '-'))])]), _c('tr', [_c('td', [_c('strong', [_vm._v("No KTP")])]), _c('td', [_vm._v(_vm._s((_vm$form$personal_dat8 = (_vm$form8 = _vm.form) === null || _vm$form8 === void 0 ? void 0 : (_vm$form8$personal_da = _vm$form8.personal_data) === null || _vm$form8$personal_da === void 0 ? void 0 : _vm$form8$personal_da.nik_ktp) !== null && _vm$form$personal_dat8 !== void 0 ? _vm$form$personal_dat8 : '-'))])]), _c('tr', [_c('td', [_c('strong', [_vm._v("Seaferer Code")])]), _c('td', [_vm._v(_vm._s((_vm$form$personal_dat9 = (_vm$form9 = _vm.form) === null || _vm$form9 === void 0 ? void 0 : (_vm$form9$personal_da = _vm$form9.personal_data) === null || _vm$form9$personal_da === void 0 ? void 0 : _vm$form9$personal_da.seaferer_code) !== null && _vm$form$personal_dat9 !== void 0 ? _vm$form$personal_dat9 : '-'))])]), _c('tr', [_c('td', [_c('strong', [_vm._v("No NPWP")])]), _c('td', [_vm._v(_vm._s((_vm$form$personal_dat10 = (_vm$form10 = _vm.form) === null || _vm$form10 === void 0 ? void 0 : (_vm$form10$personal_d = _vm$form10.personal_data) === null || _vm$form10$personal_d === void 0 ? void 0 : _vm$form10$personal_d.npwp_number) !== null && _vm$form$personal_dat10 !== void 0 ? _vm$form$personal_dat10 : '-'))])]), _c('tr', [_c('td', [_c('strong', [_vm._v("Status")])]), _c('td', [_vm._v(_vm._s((_vm$form$personal_dat11 = (_vm$form11 = _vm.form) === null || _vm$form11 === void 0 ? void 0 : (_vm$form11$personal_d = _vm$form11.personal_data) === null || _vm$form11$personal_d === void 0 ? void 0 : (_vm$form11$personal_d2 = _vm$form11$personal_d.marital_status) === null || _vm$form11$personal_d2 === void 0 ? void 0 : _vm$form11$personal_d2.name) !== null && _vm$form$personal_dat11 !== void 0 ? _vm$form$personal_dat11 : '-'))])]), _c('tr', [_c('td', [_c('strong', [_vm._v("Anak Sendiri")])]), _c('td', [_vm._v(_vm._s((_vm$form$personal_dat12 = (_vm$form12 = _vm.form) === null || _vm$form12 === void 0 ? void 0 : (_vm$form12$personal_d = _vm$form12.personal_data) === null || _vm$form12$personal_d === void 0 ? void 0 : _vm$form12$personal_d.number_of_children) !== null && _vm$form$personal_dat12 !== void 0 ? _vm$form$personal_dat12 : '-') + " Orang")])]), _c('tr', [_c('td', [_c('strong', [_vm._v("Golongan Darah")])]), _c('td', [_vm._v(_vm._s((_vm$form$personal_dat13 = (_vm$form13 = _vm.form) === null || _vm$form13 === void 0 ? void 0 : (_vm$form13$personal_d = _vm$form13.personal_data) === null || _vm$form13$personal_d === void 0 ? void 0 : (_vm$form13$personal_d2 = _vm$form13$personal_d.blood_type) === null || _vm$form13$personal_d2 === void 0 ? void 0 : _vm$form13$personal_d2.alias) !== null && _vm$form$personal_dat13 !== void 0 ? _vm$form$personal_dat13 : '-'))])]), _c('tr', [_c('td', [_c('strong', [_vm._v("Agama")])]), _c('td', [_vm._v(_vm._s((_vm$form$personal_dat14 = (_vm$form14 = _vm.form) === null || _vm$form14 === void 0 ? void 0 : (_vm$form14$personal_d = _vm$form14.personal_data) === null || _vm$form14$personal_d === void 0 ? void 0 : (_vm$form14$personal_d2 = _vm$form14$personal_d.religion) === null || _vm$form14$personal_d2 === void 0 ? void 0 : _vm$form14$personal_d2.name) !== null && _vm$form$personal_dat14 !== void 0 ? _vm$form$personal_dat14 : '-'))])]), _c('tr', [_c('td', {
          attrs: {
            "colspan": "2"
          }
        }, [_c('strong', [_vm._v("Alamat KTP")])])]), _c('tr', [_c('td', {
          attrs: {
            "colspan": "2"
          }
        }, [_vm._v(" " + _vm._s((_vm$form$alamat_ktp$ = (_vm$form15 = _vm.form) === null || _vm$form15 === void 0 ? void 0 : (_vm$form15$alamat_ktp = _vm$form15.alamat_ktp) === null || _vm$form15$alamat_ktp === void 0 ? void 0 : (_vm$form15$alamat_ktp2 = _vm$form15$alamat_ktp[0]) === null || _vm$form15$alamat_ktp2 === void 0 ? void 0 : _vm$form15$alamat_ktp2.alamat) !== null && _vm$form$alamat_ktp$ !== void 0 ? _vm$form$alamat_ktp$ : '-') + " ")])]), _c('tr', [_c('td', {
          attrs: {
            "colspan": "2"
          }
        }, [_c('strong', [_vm._v("Alamat Domisili")])])]), _c('tr', [_c('td', {
          attrs: {
            "colspan": "2"
          }
        }, [_vm._v(" " + _vm._s((_vm$form$alamat_domis = (_vm$form16 = _vm.form) === null || _vm$form16 === void 0 ? void 0 : (_vm$form16$alamat_dom = _vm$form16.alamat_domisili) === null || _vm$form16$alamat_dom === void 0 ? void 0 : (_vm$form16$alamat_dom2 = _vm$form16$alamat_dom[0]) === null || _vm$form16$alamat_dom2 === void 0 ? void 0 : _vm$form16$alamat_dom2.alamat) !== null && _vm$form$alamat_domis !== void 0 ? _vm$form$alamat_domis : '-') + " ")])])])])];
      },
      proxy: true
    }])
  }), _c('iq-card', {
    scopedSlots: _vm._u([{
      key: "body",
      fn: function fn() {
        var _vm$form$personal_dat15, _vm$form17, _vm$form17$personal_d, _vm$form$personal_dat16, _vm$form18, _vm$form18$personal_d, _vm$form$personal_dat17, _vm$form19, _vm$form19$personal_d, _vm$form$personal_dat18, _vm$form20, _vm$form20$personal_d;
        return [_c('table', {
          staticClass: "table table-striped"
        }, [_c('tbody', [_c('tr', {
          staticClass: "bg-info"
        }, [_c('td', {
          staticClass: "text-center",
          attrs: {
            "colspan": "2"
          }
        }, [_c('strong', [_vm._v("EMERGENCY CALL")])])]), _c('tr', [_c('td', [_c('strong', [_vm._v("Nama Lengkap")])]), _c('td', [_vm._v(_vm._s((_vm$form$personal_dat15 = (_vm$form17 = _vm.form) === null || _vm$form17 === void 0 ? void 0 : (_vm$form17$personal_d = _vm$form17.personal_data) === null || _vm$form17$personal_d === void 0 ? void 0 : _vm$form17$personal_d.family_emergency_name) !== null && _vm$form$personal_dat15 !== void 0 ? _vm$form$personal_dat15 : '-'))])]), _c('tr', [_c('td', [_c('strong', [_vm._v("No. Tlp/HP")])]), _c('td', [_vm._v(_vm._s((_vm$form$personal_dat16 = (_vm$form18 = _vm.form) === null || _vm$form18 === void 0 ? void 0 : (_vm$form18$personal_d = _vm$form18.personal_data) === null || _vm$form18$personal_d === void 0 ? void 0 : _vm$form18$personal_d.emergency_number) !== null && _vm$form$personal_dat16 !== void 0 ? _vm$form$personal_dat16 : '-'))])]), _c('tr', [_c('td', [_c('strong', [_vm._v("Hubungan")])]), _c('td', [_vm._v(_vm._s((_vm$form$personal_dat17 = (_vm$form19 = _vm.form) === null || _vm$form19 === void 0 ? void 0 : (_vm$form19$personal_d = _vm$form19.personal_data) === null || _vm$form19$personal_d === void 0 ? void 0 : _vm$form19$personal_d.family_emergency_status) !== null && _vm$form$personal_dat17 !== void 0 ? _vm$form$personal_dat17 : '-'))])]), _c('tr', [_c('td', [_c('strong', [_vm._v("Alamat")])]), _c('td', {
          attrs: {
            "colspan": "2"
          }
        }, [_vm._v(" " + _vm._s((_vm$form$personal_dat18 = (_vm$form20 = _vm.form) === null || _vm$form20 === void 0 ? void 0 : (_vm$form20$personal_d = _vm$form20.personal_data) === null || _vm$form20$personal_d === void 0 ? void 0 : _vm$form20$personal_d.family_emergency_address) !== null && _vm$form$personal_dat18 !== void 0 ? _vm$form$personal_dat18 : '-') + " ")])])])])];
      },
      proxy: true
    }])
  }), _c('iq-card', {
    scopedSlots: _vm._u([{
      key: "body",
      fn: function fn() {
        var _vm$form21;
        return [_c('table', {
          staticClass: "table table-striped"
        }, [_c('tbody', [_c('tr', {
          staticClass: "bg-info"
        }, [_c('td', {
          staticClass: "text-center",
          attrs: {
            "colspan": "2"
          }
        }, [_c('strong', [_vm._v("SUPPORT DOCUMENT")])])]), _vm._l((_vm$form21 = _vm.form) === null || _vm$form21 === void 0 ? void 0 : _vm$form21.support_document, function (state, index) {
          return _c('tr', {
            key: index
          }, [_c('td', {
            attrs: {
              "width": "90%"
            }
          }, [_c('strong', [_vm._v(_vm._s(state.document_list.name))])]), _c('td', {
            staticClass: "text-center",
            attrs: {
              "width": "10%"
            }
          }, [state.file ? _c('a', {
            attrs: {
              "href": ""
            }
          }, [_c('i', {
            staticClass: "fas fa-download mr-3 text-primary"
          })]) : _vm._e()])]);
        })], 2)])];
      },
      proxy: true
    }])
  })], 1), _c('b-col', {
    attrs: {
      "lg": "8"
    }
  }, [_c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title text-primary"
        }, [_vm._v("PENDIDIKAN")])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        var _vm$form22;
        return [_c('table', {
          staticClass: "table table-striped mb-0"
        }, [_c('thead', [_c('tr', [_c('th', {
          staticClass: "align-middle text-center"
        }, [_vm._v("Sekolah/Universitas")]), _c('th', {
          staticClass: "align-middle text-center"
        }, [_vm._v("Jenjang")]), _c('th', {
          staticClass: "align-middle text-center"
        }, [_vm._v("IPK/Nilai Akhir")]), _c('th', {
          staticClass: "align-middle text-center"
        }, [_vm._v("Tahun Mulai")]), _c('th', {
          staticClass: "align-middle text-center"
        }, [_vm._v("Tahun Selesai")]), _c('th', {
          staticClass: "align-middle text-center"
        }, [_vm._v("Kota/Negara")])])]), _c('tbody', _vm._l((_vm$form22 = _vm.form) === null || _vm$form22 === void 0 ? void 0 : _vm$form22.pendidikan, function (state, index) {
          var _state$sekolah, _state$jenjang, _state$nilai, _state$tahun_mulai, _state$tahun_selesai;
          return _c('tr', {
            key: index
          }, [_c('td', [_vm._v(_vm._s((_state$sekolah = state === null || state === void 0 ? void 0 : state.sekolah) !== null && _state$sekolah !== void 0 ? _state$sekolah : '-'))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s((_state$jenjang = state === null || state === void 0 ? void 0 : state.jenjang) !== null && _state$jenjang !== void 0 ? _state$jenjang : '-'))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s((_state$nilai = state === null || state === void 0 ? void 0 : state.nilai) !== null && _state$nilai !== void 0 ? _state$nilai : '-'))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s((_state$tahun_mulai = state === null || state === void 0 ? void 0 : state.tahun_mulai) !== null && _state$tahun_mulai !== void 0 ? _state$tahun_mulai : '-'))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s((_state$tahun_selesai = state === null || state === void 0 ? void 0 : state.tahun_selesai) !== null && _state$tahun_selesai !== void 0 ? _state$tahun_selesai : '-'))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(state === null || state === void 0 ? void 0 : state.kota) + " / " + _vm._s(state === null || state === void 0 ? void 0 : state.negara))])]);
        }), 0)])];
      },
      proxy: true
    }])
  }), _c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title text-primary"
        }, [_vm._v("DATA KELUARGA")])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        var _vm$form23;
        return [_c('table', {
          staticClass: "table table-striped mb-0"
        }, [_c('thead', [_c('tr', [_c('th', {
          staticClass: "text-center"
        }, [_vm._v("No")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Nama Lengkap")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Hubungan")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Jenis Kelamin")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Umur")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Pekerjaan")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("No.Hp")])])]), _c('tbody', _vm._l((_vm$form23 = _vm.form) === null || _vm$form23 === void 0 ? void 0 : _vm$form23.family, function (state, index) {
          return _c('tr', {
            key: index
          }, [_c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(index + 1))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(state.nama_lengkap))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(state.status))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(state.jenis_kelamin))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(state.age_family))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(state.pekerjaan))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(state.no_hp))])]);
        }), 0)])];
      },
      proxy: true
    }])
  }), _c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title text-primary"
        }, [_vm._v("TRAVEL DOCUMENT")])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        var _vm$form24;
        return [_c('table', {
          staticClass: "table table-striped mb-0"
        }, [_c('thead', [_c('tr', [_c('th', {
          staticClass: "text-center"
        }, [_vm._v("No")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Nama Document")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("No Dokument")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Place & Date Issued")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Masa Berlaku")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("File")])])]), _c('tbody', _vm._l((_vm$form24 = _vm.form) === null || _vm$form24 === void 0 ? void 0 : _vm$form24.travel_document, function (state, index) {
          return _c('tr', {
            key: index
          }, [_c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(index + 1))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(state.document_name))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(state.document_number))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(state.date_issued + ', ' + state.place_issued))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(state.validity_period))]), state.file ? _c('td', {
            staticClass: "text-center"
          }, [_c('a', {
            attrs: {
              "href": state === null || state === void 0 ? void 0 : state.file,
              "download": ""
            }
          }, [_c('i', {
            staticClass: "fa fa-file-alt text-primary"
          })])]) : _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s('-'))])]);
        }), 0)])];
      },
      proxy: true
    }])
  }), _c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title text-primary"
        }, [_vm._v("CERTIFICATE OF COMPETENCY")])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        var _vm$form25;
        return [_c('table', {
          staticClass: "table table-striped mb-0"
        }, [_c('thead', [_c('tr', [_c('th', {
          staticClass: "text-center"
        }, [_vm._v("No")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Ijazah & Endorse")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Nomor Sertifikat")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Place & Date Issued")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Masa Berlaku")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("File")])])]), _c('tbody', _vm._l((_vm$form25 = _vm.form) === null || _vm$form25 === void 0 ? void 0 : _vm$form25.certificate_competency, function (state, index) {
          return _c('tr', {
            key: index
          }, [_c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(index + 1))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(state.document_name))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(state.document_number))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(state.date_issued + ', ' + state.place_issued))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(state.validity_period))]), state.file ? _c('td', {
            staticClass: "text-center"
          }, [_c('a', {
            attrs: {
              "href": state === null || state === void 0 ? void 0 : state.file,
              "download": ""
            }
          }, [_c('i', {
            staticClass: "fa fa-file-alt text-primary"
          })])]) : _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s('-'))])]);
        }), 0)])];
      },
      proxy: true
    }])
  }), _c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title text-primary"
        }, [_vm._v("CERTIFICATE OF PROFICIENCY")])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        var _vm$form26;
        return [_c('table', {
          staticClass: "table table-striped mb-0"
        }, [_c('thead', [_c('tr', [_c('th', {
          staticClass: "text-center"
        }, [_vm._v("No")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Nama Sertifikat")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Nomor Sertifikat")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Place & Date Issued")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Masa Berlaku")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("File")])])]), _c('tbody', _vm._l((_vm$form26 = _vm.form) === null || _vm$form26 === void 0 ? void 0 : _vm$form26.certificate_proficiency, function (state, index) {
          return _c('tr', {
            key: index
          }, [_c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(index + 1))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(state.document_name))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(state.document_number))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(state.date_issued + ', ' + state.place_issued))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(state.validity_period))]), state.file ? _c('td', {
            staticClass: "text-center"
          }, [_c('a', {
            attrs: {
              "href": state === null || state === void 0 ? void 0 : state.file,
              "download": ""
            }
          }, [_c('i', {
            staticClass: "fa fa-file-alt text-primary"
          })])]) : _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s('-'))])]);
        }), 0)])];
      },
      proxy: true
    }])
  }), _c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title text-primary"
        }, [_vm._v("PENGALAMAN BERLAYAR, MINIMAL 5 PENGALAMAN TERAKHIR")])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        var _vm$form27;
        return [_c('table', {
          staticClass: "table table-striped mb-0"
        }, [_c('thead', [_c('tr', [_c('th', {
          staticClass: "text-center"
        }, [_vm._v("No")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Nama Kapal")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Pemilik")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Bendera")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Kawasan")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Jabatan")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("No.Tlp Perusahaan")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Tanggal Bergabung")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Tanggal Berhenti")])])]), _c('tbody', _vm._l((_vm$form27 = _vm.form) === null || _vm$form27 === void 0 ? void 0 : _vm$form27.sail_experience, function (state, index) {
          return _c('tr', {
            key: index
          }, [_c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(index + 1))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(state.ship_name))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(state.owner))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(state.flag))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(state.area))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(state.position_id))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(state.no_number_company))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(state.date_join))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(state.date_end))])]);
        }), 0)])];
      },
      proxy: true
    }])
  }), _c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title text-primary"
        }, [_vm._v("ORGANISASI")])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        var _vm$form28;
        return [_c('table', {
          staticClass: "table table-striped mb-0"
        }, [_c('thead', [_c('tr', [_c('th', {
          staticClass: "text-center"
        }, [_vm._v("Nama Organisasi")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Jabatan")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Tanggal Bergabung")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Tanggal Selesai")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Notes")])])]), _c('tbody', _vm._l((_vm$form28 = _vm.form) === null || _vm$form28 === void 0 ? void 0 : _vm$form28.organisasi, function (state, index) {
          return _c('tr', {
            key: index
          }, [_c('td', [_vm._v(_vm._s(state === null || state === void 0 ? void 0 : state.nama_organisasi))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(state === null || state === void 0 ? void 0 : state.posisi) + " "), _c('br'), _c('b-badge', {
            attrs: {
              "variant": "primary"
            }
          }, [_vm._v(_vm._s(state === null || state === void 0 ? void 0 : state.tempat))])], 1), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(state === null || state === void 0 ? void 0 : state.durasi_awal))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(state === null || state === void 0 ? void 0 : state.durasi_akhir))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v("-")])]);
        }), 0)])];
      },
      proxy: true
    }])
  })], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }